export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-md mx-auto">
            漫画投稿、合作咨询或追更建议，欢迎通过以下方式与我们联系
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <a
              href="mailto:contact@uumanhua.com"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-mail-line"></i>
              投稿合作邮箱
            </a>
            <div className="flex items-center gap-3 text-sm text-foreground-500">
              <i className="ri-wechat-line text-lg text-accent-500"></i>
              <span>微信公众号：UU漫画</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-foreground-500">
              <i className="ri-share-line text-lg text-accent-500"></i>
              <span>微博：@UU漫画官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}